import { createContext } from 'react';
import { DEFAULT_LANG, LANGUAGES, getLanguage } from './config';

// Valeur par défaut = français seul : un composant rendu hors du fournisseur (test, aperçu) fonctionne.
export const I18nContext = createContext({
  lang: DEFAULT_LANG,
  urlLang: DEFAULT_LANG,
  locale: getLanguage(DEFAULT_LANG).locale,
  languages: LANGUAGES,
  setLanguage: () => {},
  setOverride: () => {},
});
